// extracted by mini-css-extract-plugin
export default {"switch-container":"styles_switch-container__VXc8a","switch":"styles_switch__vhQRV","slider":"styles_slider__iKtsW"};